<template>
  <div class="ic-name-search">
    <div class="ic-name-search__content">
      <h1 class="ic-name-search__title" v-text="title" />
      <h2 class="ic-name-search__subtext">
        Find Email Addresses, Phone Numbers, Social Media Data, Contact
        Information and More!
      </h2>
      <form
        class="ic-name-search__form"
        method="POST"
        novalidate
        autocomplete="off"
        @submit.prevent="handleSearch"
      >
        <div class="ic-name-search__form-group">
          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            maxlength="255"
            class="ic-name-search__input-field"
            :class="{ 'ic-name-search__input-field--error': hasError }"
            v-model="searchFirstname"
            @keypress="onTextInput($event)"
          />
        </div>
        <div class="ic-name-search__form-group">
          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            maxlength="255"
            class="ic-name-search__input-field"
            :class="{ 'ic-name-search__input-field--error': hasError }"
            v-model="searchLastname"
            @keypress="onTextInput($event)"
          />
        </div>
        <div class="ic-name-search__form-group">
          <button class="ic-name-search__button">
            Search
            <img
              aria-hidden="true"
              alt="Search Button Icon"
              class="ic-name-search__button-image"
              src="@/assets/images/icons/right-arrow.svg"
              loading="lazy"
              height="12"
              width="12"
            />
          </button>
        </div>
      </form>
      <div class="ic-name-search__secured">
        <p
          class="ic-name-search__secured-title"
          v-text="`This connection is secured`"
        />
        <p
          class="ic-name-search__secured-subtext"
          v-text="`35,583,311 Searches This Year`"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'name-search',
  data() {
    return {
      searchFirstname: '',
      searchLastname: '',
      hasError: false,
      title: ''
    };
  },
  async asyncData({ route, error }) {
    try {
      const capitalize = str => {
        str = str.split(' ');
        for (var i = 0, x = str.length; i < x; i++) {
          str[i] = str[i][0].toUpperCase() + str[i].substr(1).toLowerCase();
        }
        return str.join(' ');
      };
      const payload = {};
      const queryName = route.params.name_address_phone_email_records;
      payload.searchName = capitalize(
        queryName.substring(0, queryName.indexOf('_'))
      );

      if (!route.query.lastName) {
        payload.searchFirstname = payload.searchName;
        payload.title = `What's ${payload.searchFirstname}'s Last Name?`;
      } else {
        payload.searchLastname = payload.searchName;
        payload.title = `Please enter a First Name to search`;
      }
      return payload;
    } catch (err) {
      return error({ statusCode: 404 });
    }
  },
  methods: {
    onTextInput(event) {
      const regex = /^[A-Za-z\s-]+$/;
      if (regex.test(event.key)) return true;
      event.preventDefault();
    },
    handleSearch() {
      if (
        !this.searchFirstname ||
        this.searchFirstname === '' ||
        !this.searchLastname ||
        this.searchLastname === ''
      ) {
        this.hasError = true;
        return false;
      }
      // Navigate to landing searching page
      const query = {
        ...this.$route.query,
        firstName: this.searchFirstname,
        lastName: this.searchLastname
      };
      const queryParams = Object.keys(query);
      const queryString = queryParams
        .map(key => key + '=' + query[key])
        .join('&');

      window.location = `https://information.com/pf/23um01/searching?${queryString}`;
    }
  },
  head() {
    const head = {
      title: `${this.searchName}'s Address, Phone, Email & Background Check, People Search | Information.com`,
      meta: [
        {
          name: 'robots',
          hid: 'robots',
          content: 'noindex, nofollow, noarchive'
        },
        {
          name: 'og:title',
          hid: 'og:title',
          content: `${this.searchName}'s Address, Phone, Email & Background Check, People Search | Information.com`
        },
        {
          name: 'keywords',
          hid: 'keywords',
          content: `${this.searchName}'s' address, ${this.searchName}'s' phone, ${this.searchName}'s email, ${this.searchName}'s background check, ${this.searchName}'s public records`
        },
        {
          name: 'description',
          hid: 'description',
          content: `Find ${this.searchName}'s phone numbers, addresses, contact information and perform a true background check on anyone.`
        },
        {
          name: 'og:description',
          hid: 'og:description',
          content: `Find ${this.searchName}'s phone numbers, addresses, contact information and perform a true background check on anyone.`
        }
      ]
    };

    return head;
  }
};
</script>
